import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 500.000000 500.000000" >
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,500.000000) scale(0.100000,-0.100000)">

<path d="M3325 3798 c-66 -89 -121 -165 -123 -170 -2 -4 17 -8 42 -8 42 0 46
-2 46 -24 0 -32 -55 -245 -80 -314 -53 -142 -165 -336 -260 -452 -262 -319
-614 -508 -1042 -560 -131 -16 -257 -9 -330 19 -67 26 -154 101 -191 164 -121
206 -45 462 167 569 99 50 237 50 354 2 9 -4 12 9 12 48 1 141 56 281 151 383
102 108 220 167 363 180 291 27 559 -186 600 -476 l12 -81 46 98 c26 55 57
128 69 163 22 63 22 63 3 100 -47 91 -146 202 -239 270 -198 144 -482 182
-714 94 -203 -77 -396 -273 -457 -466 l-17 -55 -60 -7 c-263 -31 -477 -213
-542 -461 -34 -133 -11 -317 56 -445 48 -93 165 -206 260 -252 120 -59 181
-70 349 -64 219 9 391 44 597 123 440 168 807 533 990 983 40 99 100 316 118
424 l6 37 54 0 c30 0 55 2 55 4 0 11 -162 336 -168 336 -4 0 -61 -73 -127
-162z"/>
<path d="M3930 3455 c0 -20 5 -25 25 -25 20 0 25 5 25 25 0 20 -5 25 -25 25
-20 0 -25 -5 -25 -25z"/>
<path d="M3752 3403 l3 -48 45 0 45 0 3 48 3 47 -51 0 -51 0 3 -47z"/>
<path d="M2580 2985 l0 -406 38 26 c20 14 72 55 114 93 l77 67 1 313 0 312
-115 0 -115 0 0 -405z"/>
<path d="M3594 3162 c-25 -16 -34 -56 -34 -150 0 -85 3 -103 21 -126 20 -25
23 -26 139 -26 152 0 150 -2 150 161 0 151 2 149 -151 149 -63 0 -119 -4 -125
-8z"/>
<path d="M2378 2083 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M2318 2063 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M1181 1954 c-34 -24 -51 -75 -51 -154 0 -115 35 -160 125 -160 90 0
125 45 125 160 0 123 -35 170 -125 170 -31 0 -60 -6 -74 -16z m97 -52 c38 -24
37 -173 0 -193 -15 -8 -27 -8 -44 2 -22 11 -24 19 -24 90 0 94 23 129 68 101z"/>
<path d="M1440 1805 l0 -165 94 0 94 0 4 30 c3 17 2 32 0 35 -3 3 -29 5 -59 5
l-53 0 0 130 0 130 -40 0 -40 0 0 -165z"/>
<path d="M1716 1818 c-20 -84 -36 -159 -36 -165 0 -8 15 -13 40 -13 33 0 40 3
40 19 0 38 11 51 46 51 30 0 34 -3 40 -35 6 -33 9 -35 45 -35 22 0 39 4 39 9
0 5 -14 70 -31 143 -18 73 -34 143 -36 156 -5 19 -11 22 -58 22 l-53 0 -36
-152z m91 -36 c-26 -5 -27 -3 -14 53 l12 50 10 -50 c10 -46 10 -50 -8 -53z"/>
<path d="M1990 1805 l0 -165 65 0 c124 0 164 36 173 151 9 131 -37 179 -173
179 l-65 0 0 -165z m144 73 c22 -30 22 -131 0 -152 -8 -9 -29 -16 -45 -16
l-29 0 0 95 0 95 29 0 c20 0 35 -8 45 -22z"/>
<path d="M2316 1820 c-20 -83 -36 -158 -36 -165 0 -11 12 -15 39 -15 37 0 40
2 43 33 3 28 7 32 37 35 37 4 51 -9 51 -45 0 -20 5 -23 40 -23 22 0 40 4 40 9
0 6 -16 78 -35 161 -19 83 -35 153 -35 156 0 2 -24 4 -54 4 l-54 0 -36 -150z
m102 2 c10 -41 9 -42 -15 -42 -18 0 -23 4 -19 18 3 9 8 30 12 45 8 35 10 32
22 -21z"/>
<path d="M2570 1935 c0 -33 2 -35 35 -35 l35 0 0 -130 0 -130 40 0 40 0 0 129
0 130 37 3 c35 3 37 5 38 36 l1 32 -113 0 -113 0 0 -35z"/>
<path d="M2905 1958 c-2 -7 -18 -76 -36 -153 -17 -77 -34 -146 -37 -153 -3
-10 6 -12 39 -10 42 3 44 5 47 36 3 30 6 32 42 32 37 0 39 -2 46 -35 6 -33 9
-35 45 -35 22 0 39 3 39 8 0 4 -17 78 -37 164 l-38 158 -53 0 c-33 0 -54 -5
-57 -12z m74 -160 c1 -12 -6 -18 -19 -18 -21 0 -21 12 -2 75 5 17 7 16 13 -10
4 -16 7 -38 8 -47z"/>
<path d="M3625 1670 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"/>
</g>
</svg>

    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
